import { render, staticRenderFns } from "./car-driving.vue?vue&type=template&id=472044ee&scoped=true&"
import script from "./car-driving.vue?vue&type=script&lang=js&"
export * from "./car-driving.vue?vue&type=script&lang=js&"
import style0 from "./car-driving.vue?vue&type=style&index=0&id=472044ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472044ee",
  null
  
)

export default component.exports